import { MessageSquare } from "lucide-react";
import { Box, TextField } from "./fields";

// Textos da secção "Aula experimental" (o formulário abre o WhatsApp com a mensagem escrita)
export default function LeadFormEditor({ content, setContent }) {
  const field = (label, key, extra = {}) => (
    <TextField label={label} field={key} content={content} setContent={setContent} {...extra} />
  );
  return (
    <Box
      title="Secção da aula experimental"
      icon={MessageSquare}
      hint="O formulário abre o WhatsApp do número indicado acima, com a mensagem já escrita. O texto do botão muda-se em Textos → Botões do site."
    >
      {field("Etiqueta (por cima do título)", "contact_eyebrow")}
      {field("Título da secção", "contact_title")}
      {field("Texto da secção", "contact_subtitle", { multiline: true, rows: 2 })}
      {field("Título do cartão", "form_title")}
      {field("Texto do cartão", "form_text", { multiline: true, rows: 2 })}
      {field("Mensagem já escrita", "form_message", { multiline: true, rows: 2 })}
      {field("Ajuda por baixo da mensagem", "form_hint")}
    </Box>
  );
}
